export const BASE_URL = 'https://backbonedev.scanandorder.eu/api';

export const CLOUDINARY_BASE_URL =
    'https://res.cloudinary.com/scanandorder/image/upload';

export const OPEN_ORDER_PATH = '/open-orders';
export const WORKING_HOURS = '/working-hours';
export const TABLES = '/tables';
export const RESERVATIONS = '/reservations';

export const TITLES = {
    [OPEN_ORDER_PATH]: 'ΤΡΕΧΟΥΣΕΣ ΑΝΟΙΧΤΕΣ ΠΑΡΑΓΓΕΛΙΕΣ',
    [WORKING_HOURS]: 'ΑΝΟΙΓΜΑ / ΚΛΕΙΣΙΜΟ',
    [TABLES]: 'ΣΥΝΟΛΟ ΤΡΑΠΕΖΙΩΝ ΚΑΤΑΣΤΗΜΑΤΟΣ',
    [RESERVATIONS]: 'ΚΡΑΤΗΣΕΙΣ'
};

export const COOKIE_TOKEN_KEY = 'api_token';
